<button
  type="button"
  class="drag-handle"
  fofDragDrop
  #dragDrop="fofDragDrop"
  [class.active]="dragDrop.isDragging()"
  i18n-aria-label="@@drag-handle.label"
  aria-label="Deplacer la fenetre de chat"
>
  <span class="drag-handle__icon" aria-hidden="true">⠿</span>
</button>
